import { z } from 'zod';
/**
 * Reason carried in the `rejectReason` field of the reject-assignment and
 * reassign-recording mutations: `'unclear'` parks the step for clarification,
 * `'re-assign'` requires the reassignee fields (enforced by
 * `refineReassigneeFields`). Shared so the two contracts stay aligned.
 */ export const RejectReasonSchema = z.enum([
    'unclear',
    're-assign'
]);

//# sourceMappingURL=reject-reason.schema.js.map